import { graphql } from '@/generated/gql';

export const INTAKE_CONFIRM_SUPPLIER_SELECTION_MUTATION = graphql(/* GraphQL */ `
  mutation IntakeConfirmSupplierSelection($data: SvbrgIntakeRequestSupplierAddInput!) {
    sevenbridges {
      chatSession {
        supplierSelection {
          confirmQuotedSupplier(data: $data) {
            id
            internalId
            isQuoted
            contact {
              firstName
              lastName
              email
              internalId
              language
            }
            location {
              address
              city
              countryCode
              internalId
              postalCode
            }
          }
        }
      }
    }
  }
`);
